import { KNOWN_COLUMN_TYPES } from '@atlassian/jira-issue-table-common/src/constants.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { issueRow_nativeIssueTable_IssueRowWithFragments_fieldSets$data } from '@atlassian/jira-relay/src/__generated__/issueRow_nativeIssueTable_IssueRowWithFragments_fieldSets.graphql';

export const getMergedFields = (
	fieldSetsData?: issueRow_nativeIssueTable_IssueRowWithFragments_fieldSets$data | null,
) => {
	const nodes = fieldSetsData?.edges?.flatMap(
		(edgeData) => edgeData?.node?.fields?.edges?.map((edge) => edge?.node) ?? [],
	);

	let issueTypeField;
	let issueKeyField;
	let summaryField;
	let fieldId;

	nodes?.forEach((node) => {
		if (node?.__typename === 'JiraIssueTypeField') {
			issueTypeField = node;
		} else if (
			node?.__typename === 'JiraSingleLineTextField' &&
			node?.type === KNOWN_COLUMN_TYPES.ISSUE_KEY
		) {
			issueKeyField = node;
		} else if (
			node?.__typename === 'JiraSingleLineTextField' &&
			node?.type === KNOWN_COLUMN_TYPES.SUMMARY
		) {
			summaryField = node;
			if (fg('issue_table_single_line_row_height_event_delegator')) {
				fieldId = node?.id;
			}
		}
	});

	return { issueTypeField, issueKeyField, summaryField, fieldId };
};
